// 这东西就不能维护个服务器的字典吗
export const rule = [
  {
    label: '包含',
    value: 4
  },
  {
    label: '正则表达式',
    value: 6
  },
  {
    label: '等于',
    value: 0
  },
  {
    label: '不等于',
    value: 1
  },
  {
    label: '不包含',
    value: 5
  }
]
export const userProperties = [
  {
    label: '国家/地区/城市',
    value: 0
  },
  {
    label: '设备类型',
    value: 1
  },
  {
    label: '新老访',
    value: 2
  },
  {
    label: '新老客',
    value: 3
  },
  {
    label: '登录状态',
    value: 4
  },
  {
    label: '订阅状态',
    value: 5
  },
  {
    label: 'UTM参数',
    value: 6
  },
  {
    label: '渠道',
    value: 7
  },
  {
    label: 'URL',
    value: 8
  }
]

export const userLabels = [
  {
    label: '新老访',
    value: 0
  },
  {
    label: '新老客',
    value: 1
  },
  {
    label: '登录状态',
    value: 2
  },
  {
    label: '订阅状态',
    value: 3
  }
]
export const userActions = [
  {
    label: 'UTM参数',
    value: 0
  },
  {
    label: '渠道',
    value: 1
  },
  {
    label: 'URL',
    value: 2
  }
]

// 0.国家/地区 1.设备类型 2.新老访 3.新老客 4.登录状态 5.订阅状态 6.UTM参数 7.渠道 8.URL
const REGION = 0
const DEVICE_TYPE = 1
const VISTOR = 2
const CUSTOMER = 3
const LOGIN_STATUS = 4
const SUBSCRIBE_STATUS = 5
const UTMPARAM = 6
const CHANNEL = 7
const URL = 8
export const AudienceType = {
  REGION,
  DEVICE_TYPE,
  VISTOR,
  CUSTOMER,
  LOGIN_STATUS,
  SUBSCRIBE_STATUS,
  UTMPARAM,
  CHANNEL,
  URL
}
export const userRule = [
  {
    label: '国家/地区/城市',
    value: REGION
  },
  {
    label: '设备类型',
    value: DEVICE_TYPE
  },
  {
    label: '新老访',
    value: VISTOR
  },
  {
    label: '新老客',
    value: CUSTOMER
  },
  {
    label: '登录状态',
    value: LOGIN_STATUS
  },
  {
    label: '订阅状态',
    value: SUBSCRIBE_STATUS
  },
  {
    label: 'UTM参数',
    value: UTMPARAM
  },
  {
    label: '渠道',
    value: CHANNEL
  },
  {
    label: 'URL',
    value: URL
  }
]

export const CONDITION_RULES = []
CONDITION_RULES[0] = [
  { label: '等于', value: 0 },
  { label: '不等于', value: 1 }
]

CONDITION_RULES[1] = [
  { label: '等于', value: 0 },
  { label: '不等于', value: 1 },
  { label: '大于', value: 2 },
  { label: '小于', value: 3 }
]

CONDITION_RULES[2] = [
  { label: '等于', value: 0 },
  { label: '不等于', value: 1 },
  { label: '包含', value: 4 },
  { label: '不包含', value: 5 },
  { label: '正则匹配', value: 6 },
  { label: '正则不匹配', value: 7 }
]

export let userTypeRule = []
userTypeRule[1] = [
  {
    label: 'ios',
    value: '1'
  },
  {
    label: 'android',
    value: '2'
  }
]
userTypeRule[2] = [
  {
    label: '新访',
    value: '1'
  },
  {
    label: '老访',
    value: '2'
  }
]
userTypeRule[3] = [
  {
    label: '新客',
    value: '1'
  },
  {
    label: '老客',
    value: '2'
  }
]
userTypeRule[4] = [
  {
    label: '登录',
    value: '1'
  },
  {
    label: '未登录',
    value: '2'
  }
]
userTypeRule[5] = [
  {
    label: 'email订阅',
    value: '1'
  },
  {
    label: 'email+sms二合一订阅',
    value: '3'
  },
  {
    label: '未订阅',
    value: '4'
  }
]
userTypeRule[7] = [
  'Meta',
  'Google',
  'Pinterest',
  'Bing',
  'Affiliate',
  'Influencer',
  'Applovin',
  'Meta-Social',
  'SNS',
  'SMS',
  'Email',
  'SEO',
  'Organic',
  'Direct',
  'AppPush',
  'WebPush',
  'ASA',
  'RTB',
  'Brand',
  'Snapchat',
  'Tiktok',
  'Twitter',
  'TT shop'
].map(item => ({
  label: item,
  value: item
}))
